import { getDisplayNameItemChanges } from "helpers/bid";
import { dateTimeToView } from "helpers/date";
import { bidItemTypes } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React, { Fragment } from "react";

const BidItemsChanges = ({ bidItemsChanges, mergeMapViewport }) => {
    return (
        <>
            <div className="show-bid__section-header">Перецепки/пересменки</div>
            <div className="show-bid__cargo-container">
                {bidItemsChanges.map((el, index) => {
                    const { location, itemChanges } = el;
                    return (
                        <Fragment key={index}>
                            <div className="show-bid__cargo-info">
                                <div className="font-weight-bold show-bid__main-info--title">Факт. дата</div>
                                <div
                                    className="show-bid__main-info--value d-flex justify-content-between"
                                    data-test-id="bid-item-change"
                                >
                                    <div className="font-weight-bold">
                                        {dateTimeToView(itemChanges[0].startedAt, "DD.MM.YYYY HH:mm (Z)")}
                                    </div>
                                    {location && location.length ? (
                                        <div
                                            className="link"
                                            onClick={() =>
                                                mergeMapViewport({ center: [...location].reverse(), zoom: 10 })
                                            }
                                        >
                                            Показать на карте
                                        </div>
                                    ) : (
                                        <div className="text-muted">Координаты не найдены</div>
                                    )}
                                </div>
                                {itemChanges.map((itemChange, i) => {
                                    const { itemType } = itemChange;
                                    return (
                                        <Fragment key={i}>
                                            <div className="show-bid__main-info--title">
                                                {enumLabel(bidItemTypes, itemType)}
                                            </div>
                                            <div className="show-bid__main-info--value">
                                                {getDisplayNameItemChanges(itemChange)}
                                            </div>
                                        </Fragment>
                                    );
                                })}
                            </div>
                            {index < bidItemsChanges.length - 1 && <hr className="mt-2 mb-2 ml-3 mr-3" />}
                        </Fragment>
                    );
                })}
            </div>
        </>
    );
};

export default BidItemsChanges;
